module.exports = __webpack_public_path__ + "static/img/zkhz_banner_muchangjiankangguanli.cf73ab77.png";